import C from '../constants';

export const language = (state = {}, action) => {
    switch (action.type) {
        case C.CHANGE_LANG:
            return {
                ...state,
                locale: action.locale,
                activeLanguage: action.activeLanguage,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/reducers/language.jsx